export default function Client({ step = 1, email = "", onEditEmail }) {
  if (step === 2) {
    return (
      <div className="client-div google-signin-client google-signin-client--step2">
        <div className="google-signin-headings google-signin-headings--step2">
          <h1>Welcome</h1>
          <button
            type="button"
            className="google-signin-account-chip"
            onClick={onEditEmail}
            aria-label="Choose another account"
          >
            <span className="google-signin-account-email">{email}</span>
            <svg
              className="google-signin-account-chevron"
              width="10"
              height="6"
              viewBox="0 0 10 6"
              aria-hidden="true"
            >
              <path
                d="M1 1l4 4 4-4"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="client-div google-signin-client google-signin-client--step1">
      <div className="google-signin-headings">
        <h1>Sign in</h1>
        <p className="google-signin-sub">to continue</p>
      </div>
    </div>
  );
}
